export { ST_REPORTS_DEFAULT_PRESET_LABEL_KEY } from "./DateRangePicker/dateRangeFormatUtils";
export var STATUS_TABS = ["All", "Paid", "Unpaid", "Draft", "Refunded"];
/** Reuses existing tab labels (`all`, `paid`, …) from locale files. */
export var STATUS_TAB_LABEL_KEYS = {
    All: "all",
    Paid: "paid",
    Unpaid: "unpaid",
    Draft: "draft",
    Refunded: "refunded",
};
/** Default page size for ST Reports table (matches `rowsPerPageOptions` first entry). */
export var ST_REPORTS_DEFAULT_ROWS_PER_PAGE = 50;
export var ST_REPORTS_ROWS_PER_PAGE_OPTIONS = [50, 100, 150, 200, 250];
/** "How it works" video for Sales Order Details / ST Reports toolbars. */
export var ST_REPORTS_HOW_IT_WORKS_URL = "https://youtu.be/t_Ouc-_UGbE?si=Mkm7tj_NhdxPx9az";
